/**
 * Observer class to handle *non-clustered* custom markers on map update
 */
export class ActiveMarkersObserver {
    constructor() {
        this._observedMarkers = [];
    }

    /**
     * @param marker {CustomOverlayView}
     */
    push(marker) {
        this._observedMarkers.push(marker);
    }

    /**
     * removes all currently observed markers
     */
    removeAll() {
        for(const observedMarker of this._observedMarkers) {
            observedMarker.setMap(null);
        }
        this._observedMarkers = [];
    }

    /**
     * @param markers {Array.<CustomOverlayView>}
     */
    updateMarkerList(markers) {
        this.removeAll();
        for (const marker of markers) {
            this.push(marker);
        }
    }
}
